module.exports = __webpack_public_path__ + "static/img/listgoods1c911d82.png";